import alerts from '../helpers/storeModuleHelpers/alerts';
import axios from 'axios';
import { BASE_URL } from '@/helpers/apiUtilities.js';

export const state = {
  data: [],
  details: {},
  ...alerts.getState()
};

export const mutations = {
  ...alerts.mutations,
  setMenu: function (state, menu) {
    state.data = menu;
  },
  setDetails: function (state, menuItem) {
    state.details = menuItem;
  }
};

export const actions = {
  getMenu: function (store) {
    if (store.state.data.length > 0) {
      return store.state.data;
    }

    const products = axios.get(BASE_URL + '/Shopify/MenuItems').then(menu => {
      if (menu.data?.products) {
        store.commit('setMenu', menu.data.products);
        return menu.data.products;
      }
      return [];
    })
      .catch((error) => {
        const alert = {
          status: 'error',
          message: 'Error retrieving menu items:',
          error
        };
        store.commit('addAlert', alert);
        return false;
      });

    return products;
  },
  getDetails: async function (store, id) {
    return store.dispatch('getMenu').then(menu => {
      // eslint-disable-next-line eqeqeq
      const details = menu.find(menuItem => menuItem.id == id);
      store.commit('setDetails', details);
      return details;
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
